import React from 'react';
import MainScreen from '../screens/MainScreen/MainScreen';
import SplashScreen from '../screens/SplashScreen/SplashScreen';
import { Route, Routes } from 'react-router';
import { ERoutes as EAppRoutes } from '../enums';
import LeaderboardScreen from '../screens/LeaderboardScreen/LeaderboardScreen';
import UserProfileScreen from '../screens/UserProfileScreen/UserProfileScreen';
import { useGateKeeperRouteChanges } from '../hooks';
import CompetitionModeScreen from '../screens/CompetitionModeScreen/CompetitionModeScreen';
import ConnectAccountByOAuthWidgetScreen from '../screens/ConnectAccountScreen/ConnectAccountByOAuthWidgetScreen';
import QuizzStartScreen from '../screens/QuizzScreen/QuizzStartScreen';
import QuizzScreen from '../screens/QuizzScreen/QuizzScreen';
import DailiesQuestsScreen from '../screens/DailyScreen/DailyQuestsScreen';
import ReferralScreen from '../screens/ReferralScreen/ReferralScreen';
import GameModesScreen from '../screens/GameModesScreen/GameModesScreen';
import GeneralModeScreen from '../screens/GeneralModeScreen/GeneralModeScreen';
import CompetitionRulesScreen from '../screens/CompetitionRulesScreen/CompetitionRulesScreen';
import GeneralRulesScreen from '../screens/GeneralRulesScreen/GeneralRulesScreen';
import FinalizeCompetitionScreen from '../screens/FinalizeCompetitionScreen/FinalizeCompetitionScreen';
import TrainingRulesScreen from '../screens/TrainingRulesScreen/TrainingRulesScreen';
import TrainingModeScreen from '../screens/TrainingModeScreen/TrainingModeScreen';
import { WithGuard } from '../components/Guards/WithGuard';

const AppRouter: React.FC = () => {
  useGateKeeperRouteChanges();

  return (
    <Routes>
      <Route path={EAppRoutes.splash} element={<SplashScreen />} />
      <Route
        path={EAppRoutes.main}
        element={
          <WithGuard>
            <MainScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.leaderboard}
        element={
          <WithGuard>
            <LeaderboardScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.competitionMode}
        element={
          <WithGuard>
            <CompetitionModeScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.userProfile}
        element={
          <WithGuard>
            <UserProfileScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.connectByTelegramOAuth}
        element={<ConnectAccountByOAuthWidgetScreen />}
      />
      <Route
        path={EAppRoutes.quizzStart}
        element={
          <WithGuard>
            <QuizzStartScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.quizz}
        element={
          <WithGuard>
            <QuizzScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.dailyQuests}
        element={
          <WithGuard>
            <DailiesQuestsScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.referral}
        element={
          <WithGuard>
            <ReferralScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.gameModes}
        element={
          <WithGuard>
            <GameModesScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.generalMode}
        element={
          <WithGuard>
            <GeneralModeScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.competitionRules}
        element={
          <WithGuard>
            <CompetitionRulesScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.generalRules}
        element={
          <WithGuard>
            <GeneralRulesScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.finalizeCompetition}
        element={
          <WithGuard>
            <FinalizeCompetitionScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.trainingRules}
        element={
          <WithGuard>
            <TrainingRulesScreen />
          </WithGuard>
        }
      />
      <Route
        path={EAppRoutes.trainingMode}
        element={
          <WithGuard>
            <TrainingModeScreen />
          </WithGuard>
        }
      />
    </Routes>
  );
};

export default AppRouter;
